export const TYPING_INTERVAL_MS = 1000 * 10;
